// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-text[data-v-f116c83a] {\n  white-space: pre-line;\n}\n", ""]);
// Exports
module.exports = exports;
